import { render, staticRenderFns } from "./AppInfoManagement.vue?vue&type=template&id=54390dd1&scoped=true"
import script from "./AppInfoManagement.vue?vue&type=script&lang=js"
export * from "./AppInfoManagement.vue?vue&type=script&lang=js"
import style0 from "./AppInfoManagement.vue?vue&type=style&index=0&id=54390dd1&prod&scoped=true&lang=css"
import style1 from "./AppInfoManagement.vue?vue&type=style&index=1&id=54390dd1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54390dd1",
  null
  
)

export default component.exports